import CellHOC from '@platform/react/hoc/list/cell'
import withAddress from 'ui/Element/List/Item/Cell/Organisation/WithAddress'

/**
 * Displays the organisation a sensor is registered for.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmRegisteredFor = (classes, props = {}) => {
  const { registeredFor: { value = {} } } = props

  return withAddress(value)
}

export default CellHOC(ListItemCellXEcoApmRegisteredFor)
